import type { RawMenuItemGroup, RawMenuItem } from '@app/types/menu/raw'

export const getFilteredMenuItemGroup = (
  rawMenuItemGroup: RawMenuItemGroup,
  childrenFilterCallback: (rawMenuItem: RawMenuItem) => boolean
): RawMenuItemGroup => ({
  ...rawMenuItemGroup,
  children: rawMenuItemGroup.children.filter(childrenFilterCallback)
})
